import i18n from 'i18next';

/**
 * @param {string} locale The shortcut language code example 'en', 'de'
 * @returns {string} The full language name
 */
export function getLanguageDisplayName(locale: string) {
  return new Intl.DisplayNames([i18n.language], { type: 'language' }).of(locale);
}
